"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import classNames from "classnames";
import { computed, observable, action, runInAction } from "mobx";
import { observer } from "mobx-react";
import React, { forwardRef, Children } from "react";
import { Transition } from "react-transition-group";
import * as utils from "../../../utils";
import { AnimationDuration } from "../../../styles/Animations";
import { Spinner } from "../Spinner/Spinner";
import forceReflow from "../../../utils/forceReflow";
import { ChevronDown, ArrowRight, Tick } from "../../icons";
import * as styles from "./Button-css";
export var ButtonType = /* @__PURE__ */function (ButtonType2) {
  ButtonType2["Primary"] = "primary";
  ButtonType2["Secondary"] = "secondary";
  ButtonType2["Tertiary"] = "tertiary";
  return ButtonType2;
}(ButtonType || {});
export var ButtonState = /* @__PURE__ */function (ButtonState2) {
  ButtonState2["Idle"] = "idle";
  ButtonState2["Waiting"] = "waiting";
  ButtonState2["Success"] = "success";
  return ButtonState2;
}(ButtonState || {});
export var ButtonSize = /* @__PURE__ */function (ButtonSize2) {
  ButtonSize2["XSmall"] = "x-small";
  ButtonSize2["Small"] = "small";
  ButtonSize2["Medium"] = "medium";
  ButtonSize2["Large"] = "large";
  return ButtonSize2;
}(ButtonSize || {});
export var ButtonDecorator = /* @__PURE__ */function (ButtonDecorator2) {
  ButtonDecorator2["Dropdown"] = "dropdown";
  ButtonDecorator2["Arrow"] = "arrow";
  return ButtonDecorator2;
}(ButtonDecorator || {});
export var ButtonTheme = /* @__PURE__ */function (ButtonTheme2) {
  ButtonTheme2["Light"] = "light";
  ButtonTheme2["Dark"] = "dark";
  return ButtonTheme2;
}(ButtonTheme || {});
var ButtonComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonComponent, _React$Component);
  var _super = _createSuper(ButtonComponent);
  function ButtonComponent(props) {
    var _this;
    _classCallCheck(this, ButtonComponent);
    _this = _super.call(this, props);
    _this.renderChild = function (child) {
      if (child === null) return;
      if (typeof child === "string") {
        return /* @__PURE__ */React.createElement("span", {
          className: classNames(styles.text, "button__text")
        }, child);
      }
      return child;
    };
    _this.id = props.id ? props.id : "button-".concat(utils.randomString());
    _this._internalButtonState = "idle" /* Idle */;
    return _this;
  }
  _createClass(ButtonComponent, [{
    key: "buttonState",
    get: function get() {
      return this.isControlled ? this.props.buttonState : this._internalButtonState;
    }
  }, {
    key: "isControlled",
    get: function get() {
      return !!this.props.buttonState;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _a = this.props,
        buttonState = _a.buttonState,
        onClick = _a.onClick,
        successMessage = _a.successMessage,
        as = _a.as,
        className = _a.className,
        type = _a.type,
        size = _a.size,
        width = _a.width,
        isRound = _a.isRound,
        disabled = _a.disabled,
        innerRef = _a.innerRef,
        children = _a.children,
        href = _a.href,
        decorator = _a.decorator,
        openInSameTab = _a.openInSameTab,
        isIconOnly = _a.isIconOnly,
        theme = _a.theme,
        isDestructive = _a.isDestructive,
        rest = __objRest(_a, ["buttonState", "onClick", "successMessage", "as", "className", "type", "size", "width", "isRound", "disabled", "innerRef", "children", "href", "decorator", "openInSameTab", "isIconOnly", "theme", "isDestructive"]);
      var ButtonElement = !!href ? "a" : as;
      var isDisabledAndIdle = disabled && this.buttonState === "idle" /* Idle */;
      var isLink = as === "a" || !!href;
      var isNonSelfReferencingLink = isLink && !!href && !/^\/[^/]/.test(href());
      return /* @__PURE__ */React.createElement(ButtonElement, __spreadValues({
        className: classNames([styles.button({
          size: size,
          type: type,
          state: this.buttonState,
          width: width,
          isRound: isRound,
          isDestructive: isDestructive,
          isIconOnly: isIconOnly
        }), "button", className, "button--".concat(type), "button--".concat(size), "button--".concat(width, "-width"), "button--id-".concat(this.id), "button--".concat(theme), _defineProperty({
          "button--icon-only": isIconOnly,
          "button--destructive": isDestructive,
          "button--is-round": isRound,
          "button--is-disabled": disabled
        }, "button--is-".concat(isLink ? "idle" /* Idle */ : this.buttonState), !isDisabledAndIdle)]),
        id: this.id,
        onClick: this.handleClick,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        ref: innerRef,
        disabled: disabled,
        href: !!href ? href() : void 0,
        target: isNonSelfReferencingLink && !openInSameTab ? "_blank" : void 0,
        rel: isNonSelfReferencingLink && !openInSameTab ? "noopener noreferrer" : void 0
      }, rest), /* @__PURE__ */React.createElement(Transition, {
        in: this.showContent,
        timeout: AnimationDuration.Medium,
        onEnter: forceReflow
      }, function (status) {
        return /* @__PURE__ */React.createElement("div", {
          className: classNames(styles.content({
            status: status
          }), "button__content", "button__content--".concat(status))
        }, Children.map(children, _this2.renderChild), decorator === "dropdown" /* Dropdown */ && /* @__PURE__ */React.createElement(ChevronDown, null), decorator === "arrow" /* Arrow */ && /* @__PURE__ */React.createElement(ArrowRight, {
          className: classNames(styles.arrowIcon, "button__arrow-icon")
        }));
      }), /* @__PURE__ */React.createElement(Transition, {
        mountOnEnter: true,
        unmountOnExit: true,
        in: this.buttonState === "waiting" /* Waiting */,
        timeout: AnimationDuration.Medium,
        onEnter: forceReflow
      }, function (status) {
        return /* @__PURE__ */React.createElement(Spinner, {
          size: "s",
          className: classNames(styles.status({
            status: status
          }), "button__spinner", "button__spinner--".concat(status))
        });
      }), /* @__PURE__ */React.createElement(Transition, {
        mountOnEnter: true,
        unmountOnExit: true,
        in: this.buttonState === "success" /* Success */,
        timeout: AnimationDuration.Medium,
        onEnter: forceReflow
      }, function (status) {
        return /* @__PURE__ */React.createElement("div", {
          className: classNames(styles.status({
            status: status
          }), "button__success", "button__success--".concat(status))
        }, !!successMessage && /* @__PURE__ */React.createElement("div", {
          className: classNames(styles.successText, "button__success-text"),
          "aria-live": "polite"
        }, successMessage), /* @__PURE__ */React.createElement(Tick, {
          className: classNames(styles.successIcon, "button__success-icon")
        }));
      }));
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this3 = this;
        var result, shouldTransitionState;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.props.onClick) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              if (!(!this.isControlled && this._internalButtonState !== "idle" /* Idle */)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              result = this.props.onClick(event);
              shouldTransitionState = !this.isControlled && result instanceof Promise;
              if (!shouldTransitionState) {
                _context.next = 17;
                break;
              }
              this._internalButtonState = "waiting" /* Waiting */;
              _context.prev = 8;
              _context.next = 11;
              return Promise.all([result, utils.delay(500)]);
            case 11:
              runInAction(function () {
                _this3._internalButtonState = "success" /* Success */;
                setTimeout(function () {
                  if (_this3._internalButtonState === "success" /* Success */) {
                    _this3._internalButtonState = "idle" /* Idle */;
                  }
                }, 3500);
              });
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](8);
              this._internalButtonState = "idle" /* Idle */;
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[8, 14]]);
      }));
    }
  }, {
    key: "showContent",
    get: function get() {
      return this.buttonState !== "waiting" /* Waiting */ && this.buttonState !== "success" /* Success */;
    }
  }]);
  return ButtonComponent;
}(React.Component);
ButtonComponent.defaultProps = {
  type: "primary" /* Primary */,
  size: "medium" /* Medium */,
  width: "normal",
  as: "button",
  theme: "light" /* Light */
};

__decorateClass([observable.ref], ButtonComponent.prototype, "_internalButtonState", 2);
__decorateClass([computed], ButtonComponent.prototype, "buttonState", 1);
__decorateClass([computed], ButtonComponent.prototype, "isControlled", 1);
__decorateClass([action.bound], ButtonComponent.prototype, "handleClick", 1);
__decorateClass([computed], ButtonComponent.prototype, "showContent", 1);
ButtonComponent = __decorateClass([observer], ButtonComponent);
var Button = forwardRef(function button(props, ref) {
  return /* @__PURE__ */React.createElement(ButtonComponent, __spreadValues({
    innerRef: ref
  }, props));
});
export default Button;